import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#116466',
        secondary: '#141414',
        accent: '#e85a4f',
        error: '#ee5f5b',
        info: '#3b9cba',
        success: '#3fa63f',
        warning: '#d67f05',
      },
    },
  },
});
